import { useState } from 'react';

const useMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    toggleMenu,
    handleMenuItemClick,
  };
};

export default useMenu;
